import { getHubOwners } from './get-hub-owners';

export const getContract = async (contract_id: string): Promise<any> => {
  const contract = (await getHubOwners()).find(({ id }) => id === contract_id);

  if (!contract) {
    throw new Error('Contract not found');
  }

  return contract;
};
